'use strict';

var PageNameIdentifiers = require('./PageNameIdentifiers');
var webutil = require('.');

// Constants
var COMPONENT_NAME = 'bankingbundlenodeweb';
var TRACKING_URL_DEV = 'https://www.msmaster.qa.paypal.com/webapps/tracking/ts';

var FLOW_TYPE_WEB = 'web';
var FLOW_TYPE_MOBILE_WEBVIEW = 'mobilewebview';

var UPGRADE_TYPE_UPGRADE = 'upgrade';
var UPGRADE_TYPE_SIGNUP_UPGRADE = 'signupupgrade';

var CIP_STATUS_WITH_CIP = 'wcip';
var CIP_STATUS_WITHOUT_CIP = 'wocip';

module.exports = {

    resolvePlaceholders: function resolvePlaceholders(str, options) {
        var data = options.data || {};
        if (!str) { return; }

        // Bundle upgrade page group placeholders
        if (str.indexOf('UPGRADE_TYPE') > -1) {
            var upgradeType = data.isSignupUpgrade ? UPGRADE_TYPE_SIGNUP_UPGRADE : UPGRADE_TYPE_UPGRADE;
            str = str.replace(/UPGRADE_TYPE/i, upgradeType);
        }

        if (str.indexOf('CIP_STATUS') > -1) {
            var cipStatus = '';
            var isCIPInfoRequired = data.isCIPInfoRequired;

            // Error pages displayed at the start of upgrade flow has an undefined isCIPInfoRequired
            // CIP status category only applies for non signup upgrade flow
            if (!data.isSignupUpgrade && typeof isCIPInfoRequired !== 'undefined') {
                cipStatus = isCIPInfoRequired ? CIP_STATUS_WITH_CIP : CIP_STATUS_WITHOUT_CIP;
            }
            str = str.replace('CIP_STATUS', cipStatus);
        }

        if (str.indexOf('REPLACE_CARD_REASON') > -1) {
            var reason = data.replaceCardReason ? data.replaceCardReason.toLowerCase().replace('_', '') : '';
            str = str.replace(/REPLACE_CARD_REASON/i, reason);
        }

        return str;
    },

    getPageDetails: function getPageDetails(options) {
        var pageDetails = {};

        try {
            // Construct Page details
            var pageGroupName;
            var pageName;

            var fptiMeta = PageNameIdentifiers.getFPTIMeta(options);

            // TODO: Old implementation, does not suppport variant
            if (fptiMeta.pageGroupName) {
                pageGroupName = this.resolvePlaceholders(fptiMeta.pageGroupName, options);
                pageName = this.resolvePageName(fptiMeta, options);
            } else if (fptiMeta.pageGroup) {
                pageGroupName = this.resolvePlaceholders(fptiMeta.pageGroup, options);
                pageGroupName += ':' + (fptiMeta.pageContent || '');
                pageName = this.formatPageName(pageGroupName, fptiMeta);
            }

            return {
                pageGroupName: pageGroupName,
                pageName: pageName
            };
        } catch (err) {
            // Error in getting Page Identifier
            if (webutil.isDebug() && console.error) {
                console.error(err.message);
            }
        }
        return pageDetails;
    },

    resolvePageName: function (fptiMeta, options) {
        return this.resolvePlaceholders(fptiMeta.pageName, options);
    },

    formatPageName: function (pageGroup, fptiMeta) {
        if (!fptiMeta) {
            return pageGroup;
        }

        var pageName = pageGroup;
        pageName += ':' + (fptiMeta.pageUserType || '');
        pageName += ':' + (fptiMeta.pageFlavor || '');
        pageName += ':' + (fptiMeta.pageTestVariant || '');

        return pageName;
    },

    setup: function setup() {
        var PAYPAL = window.PAYPAL;
        // TODO Analytics constructor throw runtime error if options object is not passed
        var analyticsInstance = new PAYPAL.analytics.Analytics({});
        window.analyticsInstance = analyticsInstance;
    },

    initDefaultOptions: function (options) {
        var fpti = window.fpti;
        if (fpti) {
            var data = options.data || {};
            fpti.comp = COMPONENT_NAME;
            fpti.fltp = data.isMobileNative ? FLOW_TYPE_MOBILE_WEBVIEW : FLOW_TYPE_WEB;

            var requestFPTI = data.requestIntent && data.requestIntent.fpti;
            if (requestFPTI) {
                fpti.intn = requestFPTI.intn;
                fpti.flfr = requestFPTI.flfr; // Traffic Source Type, e.g. mktg, 8ball, etc.

                // Traffic source
                if (requestFPTI.tsrce) { fpti.tsrce = requestFPTI.tsrce; }

                // PepperJam
                if (requestFPTI.pubid) { fpti.pubid = requestFPTI.pubid; }
                if (requestFPTI.clid) { fpti.clid = requestFPTI.clid; }
            }
        }
    },

    reset: function reset(options) {
        var fpti = window.fpti || {};

        // Do not reset if page name and group override is required, so data-pa-xxx would be able
        // to use previously set page group and page nam;e
        if (options.id) {
            delete fpti.pgrp;
            delete fpti.page;
        }

        delete fpti.pglk;
        delete fpti.pgln;
        delete fpti.erpg;
        delete fpti.erfd;
        delete fpti.eccd;
        delete fpti.goal;
    },

    trackPage: function trackPage(options) {
        if (!this.trackPageAfterSetup) {
            // Wait for analytics setup to complete so that additional init params
            // have been initialized
            var self = this;

            if (PAYPAL.analytics.setupCompleted) {
                this.initDefaultOptions(options);
                this.trackPageImpression(options);
            } else {
                PAYPAL.analytics.setupComplete = function () {
                    self.initDefaultOptions(options);
                    self.trackPageImpression(options);
                };
            }
            this.trackPageAfterSetup = true;
        } else {
            this.trackPageImpression(options);
        }
    },

    trackLink: function trackLink(options) {
        var analyticsInstance = window.analyticsInstance;
        var fpti = window.fpti || {};

        this.reset(options);
        this.setPageGroupAndName(options);

        fpti.pglk = (fpti.pgrp || '') + '|' + options.link;
        fpti.pgln = (fpti.page || '') + '|' + options.link;

        var clickOptions = {
            unloadDelay: 500
        };

        if (webutil.isDebug()) {
            clickOptions.url = 'https://tracking.qa.paypal.com/webapps/tracking/ts';
        }

        var requestData = options.requestData || {};
        requestData.link = options.link;

        this.setRequestData(requestData);
        analyticsInstance.recordClick(clickOptions);
        this.removeRequestData(requestData);
    },

    trackError: function trackError(options) {
        this.reset(options);
        this.setPageGroupAndName(options);

        // comma-delimit erfd and ercd for multiple fields error with no space in between
        var requestData = options.requestData || {};
        requestData.erpg = options.errorMessage;
        requestData.erfd = options.errorField;
        requestData.eccd = options.errorCode;

        this.setRequestData(requestData);
        this.recordImpression();
        this.removeRequestData(requestData);
    },

    setPageGroupAndName: function (options) {
        var fpti = window.fpti || {};

        if (options && options.id) {
            var pageDetails = this.getPageDetails(options);
            fpti.pgrp = pageDetails.pageGroupName;
            fpti.page = pageDetails.pageName;
        }
    },

    trackPageImpression: function (options) {
        this.reset(options);
        this.setPageGroupAndName(options);

        var requestData = options.requestData || {};
        requestData.erpg = requestData.erpg || options.errorMessage;

        this.setRequestData(requestData);
        this.recordImpression();
        this.removeRequestData(requestData);
    },

    recordImpression: function () {
        var recordOptions;
        if (webutil.isDebug()) {
            recordOptions = { url: TRACKING_URL_DEV };
        }
        window.analyticsInstance.recordImpression(recordOptions);
    },

    setRequestData: function (requestData) {
        if (!requestData) { return; }

        var fpti = window.fpti;
        if (fpti) {
            Object.assign(fpti, requestData);
        }
    },

    removeRequestData: function (requestData) {
        if (!requestData) {
            return;
        }

        var analytics = window.analyticsInstance;
        if (analytics) {
            Object.keys(requestData).forEach(function (key) {
                analytics.removeRequestData(key);
            });
        }
    }
};



// WEBPACK FOOTER //
// ./public/js/utils/Analytics.js